import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import Button from '../Button/Button';
import StravaLogo from './StravaLogo';

import styles from './StravaButton.scss';

export type StravaButtonProps = {
  onStravaAuth?: () => void;
  onModalOpen?: () => void;
  isConnected?: boolean;
};

export const StravaButton: FunctionComponent<StravaButtonProps> = ({
  onModalOpen,
  onStravaAuth,
  isConnected,
}) => {
  const content = (() => {
    if (!isConnected) {
      return {
        buttonText: (
          <Trans i18nKey="strava.connectButton" components={[<StravaLogo />]} />
        ),
        onClick: onStravaAuth,
        trackingData: {
          event: 'link click',
          subtype: 'button',
          page_section: 'main fundraising page',
        },
      };
    }

    return {
      buttonText: (
        <Trans i18nKey="strava.settingsButton" components={[<StravaLogo />]} />
      ),
      onClick: onModalOpen,
      trackingData: {
        event: 'link click',
        subtype: 'button',
        page_section: 'main fundraising page',
      },
    };
  })();

  return (
    <Button
      type="button"
      onClick={content.onClick}
      fullWidth
      className={styles.button}
      trackingData={content.trackingData}
    >
      {content.buttonText}
    </Button>
  );
};
